import * as React from 'react'
const SvgPreviousArrowIcon = (props) => (
  <svg
    width="36"
    height="17"
    viewBox="0 0 36 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.8055 8.5497H1.19434M1.19434 8.5497L7.99989 15.3553M1.19434 8.5497L7.99989 1.74414"
      stroke="#98A2B3"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgPreviousArrowIcon
